import { useState } from 'react';
import { GmailConnectAction, useGmailConnect, GmailAutoReplyPreference, GmailSetupResult, useGmailConnection } from './GmailConnection';
import { EmailDemo } from './MailSurface';
import styles from './GmailAutomationLanding.module.css';

export function GmailAutomationLanding() {
  const [autoReply, setAutoReply] = useState(true);
  const query = useGmailConnection();
  const connection = query.data?.connections[0];
  const needsSettings = ['paused', 'disconnecting'].includes(connection?.status ?? '');
  const connect = useGmailConnect({ autoReply, reconnect: connection?.status === 'reconnect_required', disabled: needsSettings || !(query.data?.canConnect ?? query.data?.enabled) });
  const connectAction = needsSettings
    ? <a className={styles.settingsLink} href="/app/settings/gmail">{connection?.status === 'paused' ? 'Resume Gmail' : 'Gmail settings'}</a>
    : <GmailConnectAction compact connection={connect} />;

  return <section className={styles.landing} aria-label="Connect Gmail for email automations">
    <div className={styles.copy}>
      <h1>Email Automations</h1>
      <p className={styles.description}>Keep conversations moving with prepared replies and timely follow-ups. You decide what gets sent.</p>
      {needsSettings && <div className={styles.connect}>{connectAction}</div>}
      {!needsSettings && <GmailAutoReplyPreference enabled={autoReply} onChange={setAutoReply} />}
      <GmailSetupResult />
      {query.data?.setupIssue && <p role="status">{query.data.setupIssue.message}</p>}
    </div>
    <div className={styles.example}><EmailDemo connectAction={connectAction} connection={needsSettings ? undefined : connect.demo} /></div>
  </section>;
}
